// @ts-nocheck

import { find } from 'lodash';

import { BoostedSportsByCategories } from '../../../constants/boostedOdds';
import { SportIds } from '../../../types/sports';

export const getBetslipFromProps = (state, props) => {
  const betslipReference = props.betslipReference;
  return find(state.entities.betslips, (betslip) =>
    betslip.betslipReference ? betslip.betslipReference.indexOf(betslipReference) !== -1 : null,
  );
};

export const getEnhancedOutcomes = (state, outcomesDetails) => {
  const { outcomes, bets, matches, tournaments, categories } = state.entities;
  const {
    outcomes: historyOutcomes,
    bets: historyBets,
    matches: historyMatches,
    tournaments: historyTournaments,
    categories: historyCategories,
  } = state.history.entities;

  return outcomesDetails.map((outcome) => {
    const entityOutcome = outcomes?.[outcome.outcomeId] ?? historyOutcomes?.[outcome.outcomeId];
    const { betId } = entityOutcome;
    const { matchId } = bets?.[betId] ?? historyBets?.[betId] ?? {};
    const { tournamentId } = matches?.[matchId] ?? historyMatches?.[matchId] ?? {};
    const { categoryId } = tournaments?.[tournamentId] ?? historyTournaments?.[tournamentId] ?? {};
    const { sportId: categorySportId } = categories?.[categoryId] ?? historyCategories?.[categoryId] ?? {};

    const selectedSportId = matches?.[matchId]?.sportId ?? historyMatches?.[matchId]?.sportId ?? categorySportId;
    const sportId = selectedSportId === SportIds.SPECIAL_ODDS ? BoostedSportsByCategories[categoryId] : selectedSportId;

    return {
      ...outcome,
      outcomeHasOccured: !!entityOutcome?.hasOccured,
      isBetbuilder: !!entityOutcome?.subOutcomes,
      sportId,
    };
  });
};
